import React, { useEffect, useState } from 'react';
import Constants from '../constants';
import Api from '../utils/Api';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { login, logout } from '../redux/userSlice';
import HomeImg from '../images/home.svg';
import Swal from 'sweetalert2'

const Home = () => {
    const user = useSelector((state) => state?.user?.user);
    const dispatch = useDispatch();
    const [account, setAccount] = useState(null)

    useEffect(() => {    
        if (user !== null) {
            getAccount()
        }
    }, [])

    const getAccount = () => {
        return Api.fetch(Constants.BACKEND_APIS.accounts(user.id), 'GET').then(resp => {
            setAccount(resp)
        }).catch(error => {
            console.log('error get account')
        })
    }

    const deactivateAccount = () => {
        getAccount()
        Swal.fire({
            background: 'rgb(38, 43, 51)',
            icon: null,
            text: 'Estas seguro que deseas desactivar tu cuenta?',
            confirmButtonText: 'Desactivar',
            cancelButtonText: 'Cancelar',
            showCancelButton: true,
            showCloseButton: true,
            customClass: {
                confirmButton: 'flex py-2 p-8 mb-8 rounded-full confirm-button',
                cancelButton: 'flex ml-4 mr-4 py-2 p-8 mb-8 rounded-full border border-gray-600 ',
                content: 'text-white'
            },
            buttonsStyling: false,
        }).then((result) => {
            if (result.isConfirmed) {
                return Api.fetch(Constants.BACKEND_APIS.deactivateAccount(account.id), 'POST').then(res => {
                    Swal.fire({
                        background: 'rgb(38, 43, 51)',
                        icon: 'success',
                        text: 'Cuenta desactivada!',
                        confirmButtonText: 'OK',
                        customClass: {
                            confirmButton: 'flex ml-auto mr-auto py-2 p-8 mb-8 rounded-full confirm-button',
                            content: 'text-white'
                        },
                        buttonsStyling: false,
                    }).then((result) => {
                        if (dispatch) {
                            dispatch(logout());
                        }
                        window.location.replace('/login')
                    })
                }).catch(error => {
                    console.log('error')
                    window.location.replace('/login')
                })
            }
        })
    }

    return (
        <>
            {/* Hero */}
            <div className='grid md:grid-cols-2 md:mt-20 mt-8 gap-4'>
                <div className='col-span-1 md:p-8 md:ml-4 flex flex-col justify-center items-start text-left px-4'>
                    <div data-aos="fade-right" data-aos-duration="800" className='section-label mb-4'>Pagos Digitales Instantáneos</div>
                    <div data-aos="fade-right" data-aos-duration="900" className='text-white text-3xl mb-5 md:text-5xl font-title uppercase leading-tight'>
                        Recibir y enviar dinero nunca fue tan fácil.
                    </div>
                    <div data-aos="fade-right" data-aos-duration="1100" className='color-dark-sky-blue text-sm md:text-lg mb-8 font-subtitle' style={{lineHeight: '1.6'}}>
                        Con Digipayments podés realizar y recibir transferencias al instante, desde cualquier dispositivo.
                    </div>
                    {user === null && (
                        <div data-aos="fade-up" data-aos-duration="1200" className='flex gap-3'>
                            <Link to="/register" className="py-2.5 px-8 rounded-full button-action text-sm font-semibold">Crear Cuenta</Link>
                            <Link to="/login" className="py-2.5 px-8 rounded-full button-outliner text-sm">Iniciar Sesión</Link>
                        </div>
                    )}
                </div>
                <div className='col-span-1 md:mr-8 flex items-center justify-center'>
                    <img data-aos="fade-left" data-aos-duration="1000" src={HomeImg} className='w-full max-w-md'/>
                </div>
            </div>

            {/* Features header */}
            <div className='mt-20 mb-10 px-4 text-center'>
                <div className='section-label mb-3 justify-center flex'>Características</div>
                <div className='text-white text-xl md:text-3xl font-subtitle'>Manejá tu dinero como quieras en una sola plataforma</div>
            </div>

            {/* Feature cards */}
            <div className='grid grid-rows-3 gap-6 mt-4 mx-4 md:mx-0 md:mt-0 md:grid-cols-3 md:grid-rows-1'>
                <div data-aos="fade-up" data-aos-duration="500" className='w-full rounded-2xl border overflow-hidden flex flex-col' style={{background: 'rgba(255,255,255,0.03)', borderColor: 'rgba(255,255,255,0.07)'}}>
                    <div className='p-6 flex flex-col h-full'>
                        <div className='w-11 h-11 rounded-xl flex items-center justify-center mb-5' style={{background: 'rgba(146, 113, 31, 0.2)', border: '1px solid rgba(146, 113, 31, 0.3)'}}>
                            <i className='bx bxs-right-top-arrow-circle text-2xl' style={{color: '#f59e0b'}}></i>
                        </div>
                        <div className='text-white font-bold text-lg mb-3'>Enviá a quién quieras</div>
                        <div className='text-gray-400 text-sm leading-relaxed flex-1'>
                            Transferí a cualquier CBU o CVU, ya sea tuyo o de terceros, de forma rápida y segura.
                        </div>
                    </div>
                </div>

                <div data-aos="fade-up" data-aos-duration="700" className='w-full rounded-2xl border overflow-hidden flex flex-col' style={{background: 'rgba(255,255,255,0.03)', borderColor: 'rgba(255,255,255,0.07)'}}>
                    <div className='p-6 flex flex-col h-full'>
                        <div className='w-11 h-11 rounded-xl flex items-center justify-center mb-5' style={{background: 'rgba(30, 106, 158, 0.2)', border: '1px solid rgba(38, 122, 182, 0.3)'}}>
                            <i className='bx bxs-down-arrow-circle text-2xl' style={{color: '#267ab6'}}></i>
                        </div>
                        <div className='text-white font-bold text-lg mb-3'>Recibí dinero al instante</div>
                        <div className='text-gray-400 text-sm leading-relaxed flex-1'>
                            Recibí dinero en tu cuenta desde cualquier CBU o CVU, disponible de inmediato.
                        </div>
                    </div>
                </div>

                <div data-aos="fade-up" data-aos-duration="900" className='w-full rounded-2xl border overflow-hidden flex flex-col' style={{background: 'rgba(255,255,255,0.03)', borderColor: 'rgba(255,255,255,0.07)'}}>
                    <div className='p-6 flex flex-col h-full'>
                        <div className='w-11 h-11 rounded-xl flex items-center justify-center mb-5' style={{background: 'rgba(55, 55, 68, 0.4)', border: '1px solid rgba(165, 167, 175, 0.2)'}}>
                            <i className='bx bx-devices text-2xl text-gray-300'></i>
                        </div>
                        <div className='text-white font-bold text-lg mb-3'>Siempre disponible</div>
                        <div className='text-gray-400 text-sm leading-relaxed flex-1'>
                            Mové tu dinero cuando y donde quieras, 24/7, desde cualquier dispositivo.
                        </div>
                    </div>
                </div>
            </div>

            {/* CTA */}
            {user !== null ? (
                <div className='flex w-full justify-center items-center mt-24 py-10 border-t border-b' style={{borderColor: 'rgba(255,255,255,0.06)'}}>
                    <Link onClick={deactivateAccount} className="py-2.5 px-10 rounded-full button-action text-sm font-semibold">Botón de arrepentimiento</Link>
                </div>
            ) : (
                <div className='flex flex-col w-full justify-center items-center mt-24 py-12 border-t border-b' style={{borderColor: 'rgba(255,255,255,0.06)'}}>
                    <div className='text-white text-2xl font-subtitle mb-2'>¿Listo para empezar?</div>
                    <div className='text-gray-400 text-sm mb-8'>Creá tu cuenta gratis y comenzá a operar hoy.</div>
                    <Link to="/register" className="py-3 px-12 rounded-full button-action text-sm font-semibold">Crear Cuenta</Link>
                </div>
            )}
        </>
    )
}

export default Home;